import { render, staticRenderFns } from "./CategoriesDiagramInformation.vue?vue&type=template&id=fe1cff8a&"
import script from "./CategoriesDiagramInformation.vue?vue&type=script&lang=js&"
export * from "./CategoriesDiagramInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports